<template>
  <div>
    <!-- 使用 Vant 的 van-popup 组件 -->
    <van-popup
      v-model="visible"
      :position="position"
      :overlay="overlay"
      class="custom-popup"
      closeable
    >
      <iframe
        :src="srcValue"
        scrolling="auto"
        style="width: 100%; height: 100%"
        frameborder="0"
      ></iframe>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'ServicPopup',
  props: {
    srcValue: {
      type: String,
      default: ''
    },
    // 控制弹窗显示的布尔值
    value: {
      type: Boolean,
      default: false
    },
    // 弹窗位置（top、bottom、left、right、center）
    position: {
      type: String,
      default: 'bottom'
    },
    // 是否显示遮罩层
    overlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: this.value // 内部状态
    }
  },
  watch: {
    // 监听外部传入的 value 值变化
    value(newVal) {
      this.visible = newVal
    },
    // 监听内部 visible 值变化，同步到外部
    visible(newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="less" scoped>
.custom-popup {
  height: 70vh;
  border-radius: 15px 15px 0 0;
}
::v-deep .van-popup__close-icon {
  color: #111111;
}
::v-deep .van-popup__close-icon--top-right {
  right: 13px !important;
  top: 13px !important;
}
</style>
